export const orderStatusoptions = [
  { label: "Completed", value: "completed" },
  { label: "Draft", value: "draft" },
];
export const stockInOutOptions = [
  { label: "In Stock", value: "In Stock" },
  { label: "Out Of Stock", value: "Out Of Stock" },
];
export const salesPurchaseStatusoptions = [
  { label: "Open", value: "open" },
  { label: "Closed", value: "closed" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Draft", value: "draft" },
];
export const paymentStatusoptions = [
  { label: "Paid", value: "paid" },
  { label: "Pending", value: "pending" },
];
export const expiryStatusoptions = [
  { label: "Expired", value: "expired" },
  { label: "Expiry in 1 month", value: "expiry in 1 month" },
  { label: "Expiry in 2 month", value: "expiry in 2 month" },
  { label: "Expiry in 3 month", value: "expiry in 3 month" },
];
export const scheduleoptions = [
  { label: "Schedule-A", value: "Schedule A" },
  { label: "Schedule-B", value: "Schedule B" },
  { label: "Schedule-C", value: "Schedule C" },
  { label: "Schedule-D", value: "Schedule D" },
];

export const customerStatusoptions = [
  { label: "Active Customers", value: "active" },
  { label: "Inactive Customers", value: "inactive" },
];
export const partyTypeFilterOptions = [
  { label: "Ecommerce", value: "is_ecommerce_cmr" },
  { label: "Vendor", value: "is_vendor_cmr" },
  { label: "Corporate", value: "is_corporate_cmr" },
  { label: "Store", value: "is_store_cmr" },
  { label: "Inter Company Sync", value: "inter_company_sync" },
];
export const paymentInSelect = [
  { label: "Customer", value: true },
  { label: "Vendor", value: false },
];
export const filterByTimePeriod = [
  { label: "Daily", value: "daily" },
  { label: "Weekly", value: "weekly" },
  { label: "Monthly", value: "monthly" },
  { label: "Quarterly", value: "quarterly" },
  { label: "Yearly", value: "yearly" },
];
export const channel_values = [
  { label: "SMS", value: "is_sms" },
  { label: "WhatsApp", value: "is_whatsapp" },
  { label: "Email", value: "is_email" },
];

export const filterByAudit = [
  { label: "In Progress", value: "in progress" },
  { label: "Completed", value: "completed" },
];
export const alertStatuses = [
  { label: "Active", value: "Active" },
  { label: "Paused", value: "Paused" },
];
export const customerTypeoptions = [
  { label: "Individual", value: "individual" },
  { label: "Business", value: "business" },
];
export const resetOptions = [
  { label: "Daily", value: "daily" },
  { label: "Weekly", value: "weekly" },
  { label: "Monthly", value: "monthly" },
  { label: "Yearly", value: "yearly" },
];

export const roundingMethodoptions = [
  { label: "No Rounding", value: "no_rounding" },
  { label: "Round to Full Decimal Amount", value: "round_full_dec_amt" },
  { label: "Round to Full Amount", value: "round_full_amt" },
  { label: "Round to Full Tens Amount", value: "round_full_tens_amt" },
];
export const roundingRuleoptions = [
  { label: "Round To Closest", value: "round_closest" },
  { label: "Round Up", value: "round_up" },
  { label: "Round Down", value: "round_down" },
];
export const stockOptions = [
  { label: "No Stock", value: "no_stock" },
  { label: "Low Stock", value: "low_stock" },
];
export const TransTypeOptions = [
  { value: "billing", label: "Billing" },
  { value: "invoice_credit_note", label: "Invoice Credit Note" },
  { value: "sales_invoice", label: "Sales Invoice" },
  { value: "sales_credit_note", label: "Sales Credit Note" },
];
